/**
 * 값이 비어 있는지 확인하는 함수입니다.
 *
 * @param val - 확인할 값
 * @returns 값이 비어 있으면 true, 그렇지 않으면 false를 반환합니다.
 */
export const isEmpty = (val: any): boolean => {
  // null과 undefined 처리
  if (val == null) return true;

  // 문자열 처리: trim()을 사용하여 공백만 있는 문자열도 비어 있다고 판단
  if (typeof val === 'string') return val.trim().length === 0;

  // 배열 처리
  if (Array.isArray(val)) return val.length === 0;

  // 객체 처리
  if (typeof val === 'object') return Object.keys(val).length === 0;

  // 숫자와 불리언 값은 비어 있지 않다고 가정
  return false;
};

/**
 * 객체를 변환하는 함수입니다.
 * @param obj 변환할 객체입니다.
 * @returns 변환된 객체의 배열입니다.
 */
export function objectEntryCodeNTitle(
  obj: Record<string, string>,
): Array<{ code: string; title: string }> {
  return Object.entries(obj).map(([code, title]) => ({
    code,
    title,
  }));
}

export function swapKeyValue(obj: { [key: string]: string }): { [key: string]: string } {
  const swapped: { [key: string]: string } = {};
  Object.entries(obj).forEach(([key, value]) => {
    swapped[value] = key;
  });
  return swapped;
}

export function convertAllToString(obj: any) {
  return Object.fromEntries(Object.entries(obj).map(([key, value]) => [key, String(value)]));
}

export const convertCdnUrl = (path: string) => {
  if (process.env.CURRENT_ENV === 'local') {
    return `/image/local${path}`;
  }
  return `${process.env.TOWN_CLOUD_IMAGE_URL}/${process.env.TOWN_CLOUD_IMAGE_PREFIX}/v${process.env.TOWN_CLOUD_IMAGE_VERSION}/optimized${path}`;
};
